/* Orders.tsx
	Une page affichant la gestion des commandes
	Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les éléments
	Utilise l'API correspondante pour les opérations de données
*/

import { faBox } from '@fortawesome/free-solid-svg-icons';
import { OrdersCrudCard } from 'features/orders';
import PageHeader from 'layout/PageHeader';

export const Orders = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faBox}
			title="Commandes fournisseurs"
			subtitle="Gérez les commandes de vos fournisseurs"
		/>
		<OrdersCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);
